module.exports = __webpack_public_path__ + "static/img/m_role.610b934.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/xk/m_role.png
// module id = YAd4
// module chunks = 7